// @ts-nocheck
import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useGetOrderDetailsQuery } from '../../../store/ApiSlice';
import CircularIndeterminate from '../../../components/loading/Loading';

const columns = [
    { id: 'imageUrl', label: 'Image', minWidth: 100 },
    { id: 'productName', label: 'Product Name', minWidth: 200 },
    { id: 'capacity', label: 'Capacity', minWidth: 80 },
    { id: 'quantity', label: 'Quantity', minWidth: 80 },
];

export default function DetailsOrder({ order_id, adminToken }) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const { data: order_detail, isLoading: isLoadingorder_detail} = useGetOrderDetailsQuery({
        token: adminToken,
        orderId: order_id,
    });

    if (isLoadingorder_detail) {
        return <CircularIndeterminate />;
    }


    const rows = order_detail
        ? order_detail.map((detail) => ({
            imageUrl: detail.imageUrl,
            productName: detail.productName,
            capacity: detail.capacity +'g',
            quantity: detail.quantity,
        }))
        : [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.productName}>
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.id === 'imageUrl' ? (
                                                        <img src={value} alt={row.productName} style={{ width: '50px', height: '50px' }} />
                                                    ) : (
                                                        value
                                                    )}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
